<template functional>
  <div :class="[ data.staticClass, data.class ]">
    <div class="c-player__btn">
      <ui-player-toggle-play></ui-player-toggle-play>
    </div>
    <div class="c-player__btn u-desktop-only">
      <i
        v-accessibility-focus="parent.seekBackward"
        class="o-icon o-icon--minus-10"
        :aria-label="parent.$t('player.seekBackward')"
      ></i>
    </div>
    <div class="c-player__btn u-desktop-only">
      <i
        v-accessibility-focus="parent.seekForward"
        class="o-icon o-icon--plus-10"
        :aria-label="parent.$t('player.seekForward')"
      ></i>
    </div>
    <div class="c-player__btn--fill">
      <ui-player-progress-bar></ui-player-progress-bar>
    </div>
    <div class="c-progress-bar__time">
      {{ parent.timeLeft }}
    </div>
    <div class="c-player__btn">
      <ui-player-volume></ui-player-volume>
    </div>
    <div class="c-player__btn">
      <ui-player-next-episode></ui-player-next-episode>
    </div>
    <div
      v-if="!parent.isEmbedded"
      class="c-player__btn"
    >
      <i
        v-accessibility-focus="parent.toggleSeasons"
        class="o-icon o-icon--episodes"
        :aria-label="parent.$t('accessibility.player.seasons')"
      ></i>
    </div>
    <div
      v-if="parent.optionsAvailable"
      class="c-player__btn"
    >
      <i
        v-accessibility-focus="parent.toggleOptions"
        :aria-label="parent.$t('accessibility.player.options')"
        class="o-icon o-icon--settings"
      ></i>
    </div>
    <div class="c-player__btn">
      <ui-player-fullscreen-btn></ui-player-fullscreen-btn>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'UiPlayerEpisode',
  };
</script>
